// extracted by mini-css-extract-plugin
export default {"TablePagination":"TablePagination_TablePagination__S2mvs","Seperator":"TablePagination_Seperator__S85y7","Icon":"TablePagination_Icon__weJKx"};